module.exports = __webpack_public_path__ + "img/feccc99ad7c08de776661b367fdd3358.0e6f5c26.png";